import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div class="flex py-8 pb-12">
      <div class="mx-auto flex flex-col items-center space-y-5 font-space-grotesk-medium text-xs text-slate-500 sm:text-sm">
        <p>© {currentYear} Ordinary LLC. All Rights Reserved.</p>
        <p>Made with ❤️ in Seattle 🌧️</p>
        <div class="grid grid-cols-2 place-items-center justify-center gap-5 sm:space-x-5 md:flex md:flex-row">
          <a href="/#pricing" class="hover:text-green-lowkey">
            <p>Pricing</p>
          </a>
          <a href="/blog/tools/will-lowkey-work-with-my-buzzer/" class="hover:text-green-lowkey">
            <p>Buzzer Compatibility Check</p>
          </a>
          <a href="/blog/what-is-a-buzz-code/" class="hover:text-green-lowkey">
            <p>What Is a Buzz Code?</p>
          </a>
          <a href="/blog/how-to-buzz-someone-into-your-apartment/" class="hover:text-green-lowkey">
            <p>How to Buzz Someone In</p>
          </a>
          <a href="/cities" class="hover:text-green-lowkey">
            <p>Cities</p>
          </a>
          <a href="/blog/" class="hover:text-green-lowkey">
            <p>Blog</p>
          </a>
          <a href="/blog/ai-assistant-buzzer/" class="hover:text-green-lowkey">
            <p>AI Assistants</p>
          </a>
          <a
            href="https://www.buzzerapi.com/?utm_source=lowkeybuzzer&utm_medium=referral&utm_campaign=footer"
            class="hover:text-green-lowkey"
          >
            <p>BuzzerAPI for Developers</p>
          </a>
        </div>
        <div class="grid grid-cols-3 place-items-center justify-center gap-5 sm:space-x-5 md:flex md:flex-row">
          <a href="/acceptable-use" class="hover:text-green-lowkey">
            <p>Acceptable Use</p>
          </a>
          <a href="/privacy" class="hover:text-green-lowkey">
            <p>Privacy Policy</p>
          </a>
          <a href="/terms" class="hover:text-green-lowkey">
            <p>Terms Of Service</p>
          </a>
          <a href="/disclaimer" class="hover:text-green-lowkey">
            <p>Disclaimer</p>
          </a>
          <a href="/cookies" class="hover:text-green-lowkey">
            <p>Cookie Policy</p>
          </a>
          <a href="mailto:support@lowkeybuzzer.com" class="hover:text-green-lowkey">
            <p>Contact</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
